module.exports = __webpack_public_path__ + "static/media/HSP-Pressure.9205a520.svg";